import { useLazyQuery } from "@apollo/client/react"; import { useState, useEffect, Fragment } from 'react';

import RestoreIcon from '@mui/icons-material/Restore';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { CustomChip } from "../../../../../components/chip/Chip";
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { adaptHistorialArray, GET_HISTORIAL_RECLAMO } from '../../../../../data/graphQL/queries/Reclamos/getHistorialReclamo';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';
import toast from 'react-hot-toast';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const estadosColor = {
  1: { isYellow: true },
  2: { isGreen: true },
  3: { isRed: true },
  4: { isRed: true },
  5: { isGreen: true }
};

const HistorialModal = ({
  idGestionReclamo,
  esEFI = false,
  estados,
  esUsuarioResponsable = false,
  isPopoverMenuOption = false
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [historial, setHistorial] = useState([]);


  const getEstado = (idEstado) => {
    const color = estadosColor[idEstado];
    const estadoName = !estados ? '' : estados?.find((x) => x.id === idEstado)?.displayName;
    return (
      <CustomChip
        label={estadoName}
        {...color}
        sx={{ marginLeft: '10px' }} />);


  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => { setOpenModal(false); };

  const [getHistorial, { data: historialData }] = useLazyQuery(GET_HISTORIAL_RECLAMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!historialData) return;

    if (!historialData?.historialReclamoByIdGestionReclamo)
      return toast.error('No se pudo cargar la información del historial, intentelo nuevamente más tarde.');

    setHistorial(adaptHistorialArray(historialData?.historialReclamoByIdGestionReclamo));
  }, [historialData]);

  useEffect(() => {
    if (!idGestionReclamo) return;
    getHistorial({ variables: { idGestionReclamo } });
  }, [idGestionReclamo]);

  return (
    <>
      {!isPopoverMenuOption && <CustomButton
        label='Historial'
        className='adjuntos-reclamo'
        disabled={false}
        onClick={handleOpenModal}
        endIcon={<RestoreIcon />}
        variant='standar' />
      }
      {isPopoverMenuOption &&
        <div onClick={handleOpenModal} aria-hidden='true'
          className='item-option clickable-option'>

          <RestoreIcon className='edit-icon' />
          <span className='toggle-action'>Historial</span>
        </div>
      }
      <CustomDialog
        open={openModal}
        title={'Historial'}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth
        id='reclamo-historial-modal'>

        <Timeline
          className="lineTime">

          {historial?.map((etapa, index) => {
            const isLast = index === historial.length - 1;
            return <Fragment key={`id-historial${etapa.id}-index-${index}`}>
              <TimelineItem>
                <TimelineOppositeContent className="leftContent">
                  <span className="date">
                    <CalendarTodayIcon className="iconCalendar" />
                    <div className='fecha-realizacion'>{!!etapa.fechaRealizacion ? moment(etapa.fechaRealizacion).format("DD/MM/YYYY HH:mm") : '-'}</div>
                  </span>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot sx={{
                    width: '4px',
                    height: '4px',
                    bgcolor: '#0063BE',
                    border: '3px solid #B9D1EB',
                    borderRadius: '50%'
                  }} />
                  {!isLast && <TimelineConnector sx={{ bgcolor: '#B9D1EB', border: '3px' }} />}
                </TimelineSeparator>
                <TimelineContent className="rightContent">
                  <Accordion className='card-contenido-detalle' defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header">

                      <div className="titulo-etapa-historial"><strong>{etapa?.etapa} </strong></div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="estadoHistorial"><strong>Usuario: </strong><span style={{ marginLeft: 5 }}>{esUsuarioResponsable && etapa?.etapa.includes('Creador') && esEFI ? '**** ****' : etapa.usuario}</span></div>
                      <div className="estadoHistorial"><strong>Estado: </strong>{getEstado(etapa.idEstado)}</div>
                      {!!etapa.descripcion && <div className="estadoHistorial"><strong>Motivo: </strong><label className='motivo-rechazo-descripcion'>{etapa.descripcion}</label></div>}
                    </AccordionDetails>
                  </Accordion>
                </TimelineContent>
              </TimelineItem>
            </Fragment>;
          })
          }
        </Timeline>
      </CustomDialog>
    </>);

};

export default HistorialModal;